export default __webpack_public_path__ + "static/media/read.e9e4a817.svg";